'use client';

import { useEffect, useState } from 'react';

/** Visible half of the palette's Control+K Meta+K binding. */
export function usePaletteShortcutHint(): string {
  // Keep server markup and the first client render identical; platform detection runs only after mount.
  const [hint, setHint] = useState('Ctrl K');
  useEffect(() => {
    const platform = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform
      ?? navigator.platform;
    if (/mac|iphone|ipad|ipod/i.test(platform)) setHint('⌘K');
  }, []);
  return hint;
}
